/**
 * Whether to show the Find My Order promo on the login page when Statsig enables it
 * and `redirecturi` (nested URL) contains `showFmo=true`.
 */
export function shouldShowFmoWidget(enableFMOForGuestUser: boolean, locationSearch: string | undefined): boolean {
  if (!enableFMOForGuestUser) return false
  if (locationSearch === undefined) return false

  try {
    const redirectUri = new URLSearchParams(locationSearch).get('redirecturi')
    return redirectUri ? new URL(redirectUri).searchParams.get('showFmo') === 'true' : false
  } catch {
    return false
  }
}
